/* eslint-disable camelcase */
import React from "react";
import { object, array, string } from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";
import { GameCard } from "./GameCard";
import { DfpComponent } from "../../ads/dfp-component";
import { useDeviceType } from "../../custom-hooks/useDeviceType";

import "./games.m.css";

export const Games = ({ collection, stories, extraProp = "" }) => {
  if (stories.length < 1) {
    return null;
  }

  const deviceType = useDeviceType();

  const {
    show_timestamp,
    show_read_time,
    show_row_title,
    show_column_separator,
    show_story_separator,
    show_row_separator,
    enable_sponsor_ad,
    sponsor_ad_details,
    show_row_ad_unit_bottom,
    CTA,
  } = get(collection, ["associated-metadata"], {});
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));

  const sectionSlug = extraProp;
  return (
    <div className="row-component" styleName="games-container">
      {show_row_title && (
        <div styleName="collection-title-container">
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enable_sponsor_ad}
            sponsorAdDetails={sponsor_ad_details}
            sponsorAdConfig={sponsorAdConfig}
            sectionSlug={sectionSlug}
          />
        </div>
      )}
      <div styleName="columns">
        <div styleName="first-column column" style={{ borderBottom: show_story_separator || "none" }}>
          {stories.slice(0, 4).map((story) => (
            <GameCard
              story={story}
              key={story.id}
              showThumbnail={true}
              showReadTime={false}
              showTimestamp={false}
              showBorder={deviceType === "mobile" ? show_story_separator : show_column_separator}
              defaultFallback={true}
              showSubheadline={true}
              buttonText={CTA}
              showCta={true}
              sectionSlug={sectionSlug}
            />
          ))}
        </div>
        {stories.length > 4 && (
          <div styleName="second-column column">
            {stories.slice(4, 8).map((story) => (
              <GameCard
                story={story}
                key={story.id}
                showThumbnail={false}
                showReadTime={show_read_time}
                showTimestamp={show_timestamp}
                showBorder={deviceType === "mobile" ? show_story_separator : show_column_separator}
                defaultFallback={false}
                buttonText={CTA}
                showSubheadline={false}
                showCta={false}
                sectionSlug={sectionSlug}
              />
            ))}
          </div>
        )}
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && (
        <DfpComponent
          adStyleName="ad-slot-size-300x250"
          id={`${pageType}-${collection.slug}-row-bottom-ad`}
          path={show_row_ad_unit_bottom}
          size={bottomAdConfig.sizes}
          viewPortSizeMapping={bottomAdConfig.view_port_size_mapping}
        />
      )}
    </div>
  );
};

Games.propTypes = {
  collection: object,
  stories: array,
  sectionSlug: string,
};

Games.storyLimit = 8;
